import * as yup from 'yup';
import Schema from '@/schema/Schema';

const CreateFormSchema = Schema.object().shape({
    name: yup.string().required('フォーマット名をご記入ください。').max(50, '50文字の以下で入力してください。').trim(),
});

export default CreateFormSchema;
